<template>
  <el-container  type="flex" class="main_container">
    <base-header>
      接龙总数：{{this.content.group_buy_total_count}}
    </base-header>
    <el-main class="chart_box">
      <base-chart
        chartUrl="group_buy_daily"
        chartText="日接龙数量"
        want="group_buy_count"
        :total="total_day"
      ></base-chart>
      <base-chart
        chartUrl="group_buy_monthly"
        chartText="月接龙数量"
        want="group_buy_count"
        :total="total_month"
      ></base-chart>
    </el-main>
  </el-container>
</template>

<script>
import chartMixin from '../../../../mixins/chart'

export default {
  name: 'DBGroupBuy',
  mixins: [chartMixin]
}
</script>
